import styled, { css } from 'styled-components';
import breakpoint from 'Styles/breakpoints';
import { Button as StyledButton } from '../Button/Button.styled';

export const QuickAdd = styled.div`
  ${({ $styleQueryMode }) => css`
    ${breakpoint('large', { mode: $styleQueryMode })} {
      display: none;
    }
  `}
`;

export const QuickAddButton = styled(StyledButton).attrs({
  'data-testid': 'quick-add'
})`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--muted-background);

  ${({ $styleQueryMode, $showSizeOptions }) => css`
    ${breakpoint('medium', { mode: $styleQueryMode })} {
      display: ${$showSizeOptions ? 'flex' : 'none'};
    }

    ${breakpoint('large', { mode: $styleQueryMode })} {
      display: none;
    }
  `}
`;

export const Options = styled.div`
  display: none;
  width: 100%;
  position: relative;

  ${({ transitionDuration, $styleQueryMode }) => css`
    ${breakpoint('medium', { mode: $styleQueryMode })} {
      display: block;

      ${transitionDuration &&
      `transition: opacity ${transitionDuration}ms cubic-bezier(0.25, 1, 0.5, 1);`}
      opacity: 0;

      &.quick-add-enter-active,
      &.quick-add-enter-done {
        opacity: 1;
      }

      &.quick-add-exit-active,
      &.quick-add-exit-done {
        opacity: 0;
      }
    }

    ${breakpoint('large', { mode: $styleQueryMode })} {
      ${transitionDuration && 'transition: unset'}
      opacity: 1;
    }
  `}
`;
